/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Card, Pagination, PaginationItem, Stack, Grid, Radio, CircularProgress, Box} from '@mui/material';
import { DataGrid, useGridApiContext, useGridState } from '@mui/x-data-grid';
import { styled } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Button, Tooltip, Icon, Menu, Fade, MenuItem } from '@material-ui/core';
import { tooltipClasses } from '@mui/material/Tooltip';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import store from '../../redux/store';

import { getAllScreens } from '../../redux/Actions/configscreens.action';
import { savePreviewPublish } from '../../redux/Actions/createConfigScreen.action';

import Notifications from '../notifications/Notifications';
import useStyles from './styles';
import noScreenImage from '../../assets/images/no-screen.svg';
import previewIcon from '../../assets/images/preview-icon.svg';
import publishIcon from '../../assets/images/publish-icon.svg';
import editIcon from '../../assets/images/edit-icon.svg';
import filterIcon from '../../assets/images/filter-icon.svg';

export default function List(theme) {
    const classes = useStyles(theme);
    const dispatch = useDispatch();
    const filterMenuItems = ['SearchUnify', 'SUVA', 'Knowbler'];

    const [rowCount, setRowCount] = useState(5);
    const [loadingPagination, setLoading] = useState(false);
    const [loadingOperation, setLoadingOperation] = useState(false);
    const [screenSelected, setScreenSelected] = useState({ product: '' });
    const [publishingScreen] = useState(false);
    const [screens, setScreens] = useState([]);
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [reload, setReload] = useState(false);
    const [operationCall, setOperationCall] = useState({ status: false, type: ''});
    const [successToast, setSuccessToast] = useState(false);
    const [failToast, setFailToast] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [productFilter, setProductFilter] = useState('')
    const [productCount, setProductCount] = useState({ su: 0, knowbler: 0, suva: 0});
    const [filterModel, setFilterModel] = useState([
        {
          columnField: 'product',
          operatorValue: 'contains',
          value: productFilter,
        }
      ]);
    const { feature6Url } = useSelector((state) => state.constants.settings);
    const handleCheckboxChange = (item) => {
        if(productFilter === item) setProductFilter('');
        else setProductFilter(item);
        setAnchorEl(null);
    }
    
    const openFilter = Boolean(anchorEl);
    const handleClickFilter = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseFilter = () => {
        setAnchorEl(null);
    };

    const fetchScreens = async () => {
        setLoading(true);
        await dispatch(getAllScreens({}));
        const screenState = store.getState().customScreensReducer;
        const list = screenState.allScreens;
        setRowCount(list.length);
        const rows = [];
        const productList = {
            SearchUnify: 0,
            Knowbler: 0,
            SUVA: 0
        }
        for (let i = 0; i < list.length; i += 1) {
            const row = list[i];
            row.id = row._id;
            row.status = row.action;
            productList[row.product] += 1;
            rows.push(row);
        }
        if (rows.length > 0) {
            setScreens(rows);
            setProductCount(productList);
        }
        setLoading(false);
    };



    const handleClose = () => setOpen(false);

    const formatDateString = (inputDate) => {
        // Parse the input date string
        const dateObject = new Date(inputDate);

        // Get individual components of the date
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        const hours = dateObject.getHours().toString().padStart(2, '0');
        const minutes = dateObject.getMinutes().toString().padStart(2, '0');
        const seconds = dateObject.getSeconds().toString().padStart(2, '0');

        // Format the date as per your requirement
        const formattedDate = `(${year}-${month}-${day} ${hours}:${minutes}:${seconds})`;

        return formattedDate;
    };

    const renderStatusColumn = (params) => (
        <div
            style={
                params.row.action === 'publish'
                    ? {
                          padding: '5px 5px',
                          backgroundColor: '#CAF8D0',
                          color: '#087922',
                          marginTop: '0px',
                        //   marginLeft: '0px',
                          marginBottom: '15px',
                          borderRadius: '10px',
                          width: 'fit-content'
                      }
                    : {
                          padding: '5px 5px',
                          backgroundColor: '#F8F6CA',
                          color: '#96960B',
                          marginTop: '0px',
                          marginBottom: '15px',
                          borderRadius: '10px',
                          width: 'fit-content'
                      }
            }
        >
            <div >
                {params.row.action === 'publish' ? (
                    <span style={{ fontWeight: 'bold', marginLeft: '10px', marginRight: '10px' }}>Published</span>
                ) : (
                    <span style={{ fontWeight: 'bold', marginLeft: '10px', marginRight: '10px' }}>Draft</span>
                )}
                <br />
                <span style={{ marginBottom: '15px', marginLeft: '10px', marginRight: '10px' }}>
                    {formatDateString(params.row.updatedAt)}
                </span>
            </div>
        </div>
    );

    const openNewTab = () => {
        window.open(feature6Url);
    };


    const previewScreen = async (params) => {

        setLoadingOperation(true);
        setOpen(true);
        const formInfo = params.row;
        const formData = new FormData();
        formData.append('name', formInfo.name);
        formData.append('product', formInfo.product);
        if(formInfo.bgImgName !== null) formData.append('backgroundImage', formInfo.bgImgNamePath);
        if(formInfo.mainImgName !== null) formData.append('mainImage', formInfo.mainImgNamePath);
        formData.append('emailId', formInfo.emailId);
        formData.append('event', true);
        formData.append('action', 'draft-preview');
        formData.append('objectId', formInfo.id);
        formData.append('outterDraftPreview', true);

        try {
            setOperationCall({ status: true, type: 'preview'});
            setLoadingOperation(true);
            await savePreviewPublish(formData);
            openNewTab();
            setLoadingOperation(false);
            setOpen(false);
        } catch (error) {
            setFailToast(!failToast);
            setLoadingOperation(false);
            setOpen(false)
        }
    };

    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#FFFFFF',
            color: '#000000',
            boxShadow: theme.shadows[1],
            fontSize: '14px',
            padding: '10px 20px'
        }
    }));

    const publishScreen = async () => {
        setLoadingOperation(true);
        const formData = new FormData();
        formData.append('name', screenSelected.name);
        formData.append('action', 'publish');
        formData.append('objectId', screenSelected.id);
        try {
            setOperationCall({ status: true, type: 'publish'});
            await savePreviewPublish(formData);
            setSuccessToast(!successToast);
            setLoadingOperation(false);
            setReload(!reload);
        } catch (error) {
            setFailToast(!failToast);
            setLoadingOperation(false);
        }
        setOpen(false);
    };


    const svgPreviewIcon = (
        <Icon className={classes.svgButtons}>
          <img alt="preview" src={previewIcon}/>
        </Icon>
      );

    const svgPublishIcon = (
        <Icon className={classes.svgButtons}>
          <img alt="preview" src={publishIcon}/>
        </Icon>
    );

    const svgEditIcon = (
        <Icon className={classes.svgButtons}>
          <img alt="preview" src={editIcon}/>
        </Icon>
    );

    const svgFilterIcon = (
        <Icon className={classes.svgButtons}>
            <img alt="preview" src={filterIcon} />
        </Icon>
    )

    const renderButtons = (params) => (
        <div className={classes.actionButtonContainer}>
            <LightTooltip
                    title={<span style={{ whiteSpace: 'pre-line' }}>Preview</span>}
                    className={classes.toolTip}
                >
                    <Button
                    className={classes.svgButtonContainer}
                    startIcon={svgPreviewIcon}
                    onClick={() => previewScreen(params)}
                />
            </LightTooltip>
            {params.row.action !== 'publish' ? (
                <LightTooltip
                title={<span style={{ whiteSpace: 'pre-line' }}>Edit</span>}
                className={classes.toolTip}
                 >
                    <Button
                        className={classes.svgButtonContainer}
                        component={Link}
                        to={`custom-screens/create/${params.row.id}`}
                        variant="text"
                        startIcon={svgEditIcon}
                    />
                </LightTooltip>
            ) : (
                <> </>
            )}
            {params.row.action !== 'publish' ? (
                <LightTooltip
                title={<span style={{ whiteSpace: 'pre-line' }}>Publish</span>}
                className={classes.toolTip}
                 >
                <Button
                    className={classes.svgButtonContainer}
                    startIcon={svgPublishIcon}
                    onClick={() => {
                        setScreenSelected(params.row);
                        setOpen(true);
                    }}
                />
                </LightTooltip>
            ) : (
                <> </>
            )}
        </div>
    );

    const CustomPagination = (props) => {
        const apiRef = useGridApiContext();
        const [state] = useGridState(apiRef);
        const classes = useStyles();

        useEffect(() => {
            apiRef.current.setPage(props.page);
        }, [props.page, apiRef]);

        return (
            <div className={classes.customPagination}>
                <span className={classes.showPaginationDesc}>
                    Showing {state.pagination.page * 10 + 1} to&nbsp;
                    {(state.pagination.page + 1) * 10} of&nbsp;
                    {state.pagination.rowCount} entries
                </span>
                <Pagination
                    className={classes.root}
                    color="primary"
                    count={state.pagination.pageCount}
                    page={state.pagination.page + 1}
                    onChange={(event, value) => apiRef.current.setPage(value - 1)}
                    ariant="outlined"
                    shape="rounded"
                    hideNextButton={false}
                    variant="outlined"
                    renderItem={(item) => (
                        <PaginationItem {...item} className={classes.pageItem} variant="text" />
                    )}
                />
            </div>
        );
    };

    const columns = [
        {
            field: 'name',
            flex: 3,
            headerName: 'Name',
            disableColumnMenu: true,
            filter: false,
            minWidth: 120,
            sortable: false,
            renderHeader: () => (
                <Grid container className={classes.header}>
                    Name
                </Grid>
            ),
            renderCell: (params) => (
                <div className={classes.alignLeftName} style={{ margin: 'auto 0', position: 'relative'}}>
                    <div>
                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', display: 'block', width: '180px'}}>
                        {params.row.name}
                        </span>
                    </div>
                    
                    {params.row.live ? (
                        <div className={classes.live}>
                            Live
                        </div>
                    ) : (
                        <> </>
                    )}
                </div>
            )
        },
        {
            field: 'emailId',
            headerName: 'Last Modified By',
            disableColumnMenu: true,
            flex: 3,
            minWidth: 120,
            filterable: false,
            sortable: false,
            renderHeader: () => (
                <Grid container className={classes.header}>
                    Last Modified By
                </Grid>
            ),
            renderCell: (params) => (
                <Grid container className={classes.alignLeft}>
                    {params.row.emailId}
                </Grid>
            )
        },
        {
            field: 'product',
            headerName: 'Product',
            flex: 3,
            minWidth: 120,
            filter: false,
            sortable: false,
            disableColumnMenu: true,
            renderHeader: () => (
                <Grid container className={classes.header}>
                    Product
                    <Button
                        id="fade-button"
                        startIcon={svgFilterIcon}
                        aria-controls={openFilter ? 'fade-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openFilter ? 'true' : undefined}
                        onClick={handleClickFilter}
                    />
                    <Menu
                        id="fade-menu"
                        className={classes.filterMenu}
                        MenuListProps={{
                        'aria-labelledby': 'fade-button',
                        }}
                        anchorEl={anchorEl}
                        open={openFilter}
                        onClose={handleCloseFilter}
                        TransitionComponent={Fade}
                    >
                        {filterMenuItems.map((item) => (
                            <MenuItem key={item} onClick={() => handleCheckboxChange(item)}>
                                <Radio 
                                checked= {productFilter === item}
                                size='small'
                                />
                                {item}
                            </MenuItem>
                        ))}
                    </Menu>
                </Grid>
            ),
            renderCell: (params) => (
                <Grid container className={classes.alignLeft}>
                    {params.row.product}
                </Grid>
            )
        },
        {
            field: 'status',
            headerName: 'Status',
            disableColumnMenu: true,
            filter: false,
            minWidth: 120,
            sortable: false,
            flex: 3,
            renderHeader: () => (
                <Grid container className={classes.header}>
                    Status
                </Grid>
            ),
            renderCell: renderStatusColumn
        },
        {
            field: 'action',
            headerName: 'Actions',
            disableColumnMenu: true,
            filter: false,
            minWidth: 170,
            sortable: false,
            flex: 3,
            renderHeader: () => (
                <Grid container className={classes.header}>
                    Actions
                </Grid>
            ),
            renderCell: renderButtons
        }
    ];

    useEffect(() => {
        if(operationCall.status) {
            if(operationCall.type === 'publish'){
                toast.success('Image Published Successfully');
            }
            setOperationCall({ status: false, type: ''});
        }
    }, [successToast]);

    useEffect(() => {
        if(operationCall.status) {
            if(operationCall.type === 'publish'){
                toast.error('Error While Publishing Image');
            }
            if(operationCall.type === 'preview'){
                toast.error('Error While Previewing Image');
            }
            setOperationCall({ status: false, type: ''});
        }
    }, [failToast]);

    useEffect(() => {
        fetchScreens();
    }, [reload]);

    useEffect(() => {
        setFilterModel([
            {
              columnField: 'product',
              operatorValue: 'contains',
              value: productFilter,
            }]);
        setRowCount(productCount[productFilter]);
        
    }, [productFilter]);

    return (
        <>
            {screens.length === 0 ? (
                <>
                    <h1 style={{ fontFamily: 'Montserrat', color: '#272727', fontWeight: '900' }}>
                        Customize Login Screen
                    </h1>
                    <div className={classes.noScreenContainer}>
                        <div>
                            <img
                                src={noScreenImage}
                                alt="no-screens"
                                style={{ margin: 'auto', display: 'block' }}
                            />
                        </div>
                        <p
                            style={{
                                fontWeight: 'bold',
                                textAlign: 'center',
                                fontFamily: 'Montserrat'
                            }}
                        >
                            No Login Screen has been added yet
                        </p>
                        <Button 
                        component={Link}
                        to="/app/custom-screens/create"
                        variant="outlined" 
                        className={classes.newScreenButton}
                        >
                            Configure Login Screen{' '}
                        </Button>
                    </div>
                </>
            ): 
            (
                <>
                <div>
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        sx={{
                            zIndex: '1300'
                        }}
                    >
                        <Box sx={loadingOperation ? {
                             position: 'absolute',
                             top: '50%',
                             left: '50%',
                             transform: 'translate(-50%, -50%)',
                             width: 'fit-content',
                             p: 4
                        } :{
                                padding: '10% 20%',
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 500,
                                bgcolor: 'background.paper',
                                borderRadius: '10px',
                                boxShadow: 24,
                                p: 4
                        }}>
                            { loadingOperation ? 
                                <>
                                <div style={{ margin: "auto", width: 'fit-content'}}>
                                <CircularProgress />
                                </div>
                                <p style={{ color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold'}}>Please Wait...</p>
                                </>
                                :
                                <>
                                <Typography 
                                id="modal-modal-title" 
                                variant="h6" 
                                component="h2"
                                className={classes.publishModal}>
                                    Are you sure you want to publish
                                    <br /> 
                                    this login screen?
                                </Typography>
                                <Typography 
                                id="modal-modal-description"
                                className={classes.publishModalProduct}
                                >
                                    {screenSelected.product}
                                </Typography>
                                <div style={{ position: "relative", marginTop: "35px", marginBottom: "55px"}}>
                                    <div 
                                        style={{ 
                                            position: "absolute",
                                            top: "60%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)"
                                        }}>
                                            <Button
                                                side="medium"
                                                disabled={publishingScreen}
                                                variant="outlined"
                                                onClick={() => setOpen(false)}
                                                className={classes.publishModalCancelButton}
                                            >
                                                {' '}
                                                Cancel{' '}
                                            </Button>
                                            <Button
                                                size="medium"
                                                variant="outlined"
                                                onClick={publishScreen}
                                                className={classes.publishModalPublishButton}
                                            >
                                                Publish
                                            </Button>
                                    </div>
                                </div>
                                </>
                            }
                        </Box>
                    </Modal>
                </div>
                <div className={classes.container}>
                    <Notifications />
                    <Card variant="outlined" className={classes.containerCard}>
                        <div className={classes.tableWrapper}>
                            <Typography
                                variant="body1"
                                className={classes.cardTitle}>
                                List of Customized Login Screens
                            </Typography>
                            <Button
                                variant="outlined"
                                component={Link}
                                to="custom-screens/create"
                                className={classes.newInstancesButton}
                            >
                                Configure Login Screen
                            </Button>
                            <div className={classes.tableContentWrapper}>
                                <DataGrid
                                    rowHeight={40}
                                    checkboxSelection={false}
                                    className={classes.gridClass}
                                    onPageChange={(newPage) => setPage(newPage)}
                                    rows={screens}
                                    columns={columns}
                                    pageSize={10}
                                    rowCount={rowCount}
                                    rowsPerPageOptions={[2]}
                                    filterModel={{ items: filterModel}}
                                    loading={loadingPagination}
                                    disableColumnSelector
                                    autoHeight
                                    hideFooter={rowCount < 10}
                                    componentsProps={{
                                        pagination: { page }
                                    }}
                                    components={{
                                        Pagination: CustomPagination,
                                        NoRowsOverlay: () => (
                                            <Stack
                                                height="100%"
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ marginTop: '200px' }}
                                            >
                                                No Screens Found
                                            </Stack>
                                        ),
                                        NoResultsOverlay: () => (
                                            <Stack
                                                height="100%"
                                                alignItems="center"
                                                justifyContent="center"
                                                style={{ marginTop: '200px' }}
                                            >
                                                No Screens Found
                                            </Stack>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </Card>
                </div>
                </>
            )}
        </>
    );
}
